/* globals window */
import BasicEditor from './ckeditor-shop-admin';

// window.CKEDITORS = window.CKEDITORS || [];
// window.CKEDITORS.push(BasicEditor);

window.BasicEditor = BasicEditor;
